export default function MySQL_OPERATORS() {
  return (
    <div>
      <h2>MySQL_OPERATORS</h2>    </div>
  );
}